export default "__VITE_ASSET__UoG$n7uR__"